module.exports = __webpack_public_path__ + "25bdaab1728151c4fb8c3ef7f9195db7.pdf";